import React from 'react'
import { Links } from './LinkStyles'

const Link = ({text,path,isActive}) => {
  return (
    <Links to={path}>{text}</Links>
  )
}

export default Link